export default "__VITE_ASSET__DCrQwSiW__"